import React, { ReactNode } from "react";
import { Offcanvas } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

interface OverlayDrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  placement?: "start" | "end" | "top" | "bottom";
  title: string;
  data?: any;
  createdOn?: string;
  createdBy?: string;
}

const ChangeLogDrawer: React.FC<OverlayDrawerProps> = ({
  open,
  onClose,
  children,
  placement = "end",
  title,
  data,
  createdOn,
  createdBy,
}) => {
  return (
    <Offcanvas
      show={open}
      onHide={onClose}
      placement={placement}
      style={{
        width: placement === "end" || placement === "start" ? "70%" : "100%",
        height: "30vh",
        maxHeight: "100vh",
      }}
    >
      <Offcanvas.Header>
        {/* Title on the left */}
        <Offcanvas.Title>{title}</Offcanvas.Title>

        {/* Right-side container */}
        <div className="d-flex align-items-center ms-auto">
          {/* Created Info */}
          {title != "Audit Log" && (
            <div
              className="d-flex align-items-center me-3"
              style={{
                color: "var(--bs-offcanvas-title-color)",
                fontSize: "14px",
              }}
            >
              <span style={{ color: "#000" }}>
                <strong>Created On</strong> {createdOn}
              </span>

              {/* Vertical Line */}
              <span
                style={{
                  height: "16px",
                  width: "1px",
                  backgroundColor: "currentColor",
                  margin: "0 10px",
                }}
              />

              <span>{createdBy}</span>
            </div>
          )}

          {/* Close Button */}
          <button
            id="log-overlay-drawer"
            className="btn btn-link p-0"
            onClick={onClose}
            style={{
              border: "none",
              background: "none",
              cursor: "pointer",
            }}
          >
            <span className="material-icons">close</span>
          </button>
        </div>
      </Offcanvas.Header>

      <Offcanvas.Body style={{ overflowY: "auto" }}>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default ChangeLogDrawer;
